import { Dom, Type } from 'main.core';
import { BitrixVue } from 'ui.vue';
import { PopupWindow } from 'main.popup';

export class B2bModal {
	constructor(options = {}) {
		// Якщо потрібно зберігати посилання на window
		this.window = (window !== window.parent ? window.parent : window);

		// Зберігаємо налаштування
		this.component = options.component; // Сам Vue-компонент (import X from 'X.vue')
		this.componentName = options.componentName || 'PopupComponent'; // Ім'я для реєстрації
		this.params = options.params || {}; // Пропси для Vue
		this.popupOptions = options.popupOptions || {}; // Налаштування BX.PopupWindow
		this.events = options.events || {}; // Події: onOpen, onClose тощо.
		this.closeEventName = options.closeEventName || 'PopupClose'; // Подія EventEmitter'а
		this.popup = null;

		this.renderInPopup();
	}

	// Ініціалізуємо Vue-додаток
	initializeVueApp(container) {
		// Реєструємо переданий компонент
		BitrixVue.component(this.componentName, this.component);

		// eslint-disable-next-line @typescript-eslint/no-this-alias,consistent-this
		const context = this;

		BitrixVue.createApp({
			beforeCreate() {
				// За бажанням, можна зберігати context у $bitrix.Application
				this.$bitrix.Application.set(context);
			},
			render(h) {
				return h(context.componentName, {
					props: context.params,
					on:    context.events
				});
			}
		}).mount(container);
	}

	// Рендеримо всередині попапа
	renderInPopup() {
		// Підготуємо налаштування попапа
		const popupId = 'vue-popup-' + Date.now();
		const defaultPopupOptions = {
			className: 'universal-popup-modal',
			width:     600,
			closeIcon: true,
			overlay:   true,
			cacheable: false,
			events:    {
				onBeforeShow: e => {
					this.initializeVueApp(e.target.contentContainer);
					Dom.addClass(document.body, 'modal-open');
				},
				onAfterClose: () => {
					this.syncBodyModalState();
				}
			}
		};

		// Збережемо налаштування, передані до popupOptions
		const mergedOptions = this.mergePopupOptions(defaultPopupOptions, this.popupOptions);
		const isBlocking = mergedOptions.blocking === true;
		const finalPopupOptions = this.preparePopupOptions(mergedOptions);

		// Створюємо спливаюче вікно
		const popup = new PopupWindow(popupId, null, finalPopupOptions);

		this.popup = popup;

		popup.popupContainer.classList.remove('popup-window');

		// Підписуємося на подію закриття ззовні
		this.window.BX.Event.EventEmitter.subscribe(this.closeEventName, () => {
			this.close();
		});

		this.params.popupId = popupId;

		popup.show();

		if (isBlocking) this.protectOverlay(popup);

		return popup;
	}

	mergePopupOptions(defaultOpts, userOpts) {
		const merged = { ...defaultOpts, ...userOpts };

		// Теперь обрабатываем events
		const defaultEvents = defaultOpts.events || {};
		const userEvents = userOpts.events || {};

		merged.events = this.mergeEvents(defaultEvents, userEvents);

		return merged;
	}

	// eslint-disable-next-line class-methods-use-this
	mergeEvents(defaultEvents, userEvents) {
		const merged = { ...defaultEvents };

		for (const eventName in userEvents) {
			if (merged[eventName]) {
				const defaultFn = merged[eventName];
				const userFn = userEvents[eventName];

				merged[eventName] = function(...args) {
					defaultFn.apply(this, args);
					userFn.apply(this, args);
				};
			}
			else merged[eventName] = userEvents[eventName];
		}

		return merged;
	}

	// eslint-disable-next-line class-methods-use-this
	preparePopupOptions(options) {
		const result = { ...options };

		if (result.blocking) {
			result.autoHide = false;
			result.closeByEsc = false;
			result.closeIcon = false;
			result.draggable = false;
			delete result.blocking;
		}

		return result;
	}

	// eslint-disable-next-line class-methods-use-this
	syncBodyModalState() {
		const hasOpenBootstrapModal = document.querySelector('.modal.show') !== null;
		const hasOpenB2bModal = Array.prototype.some.call(document.querySelectorAll('.universal-popup-modal'), popup => window.getComputedStyle(popup).display !== 'none');

		if (hasOpenBootstrapModal || hasOpenB2bModal) {
			Dom.addClass(document.body, 'modal-open');

			return;
		}

		Dom.removeClass(document.body, 'modal-open');
	}

	close() {
		if (this.popup) this.popup.close();
	}

	// eslint-disable-next-line class-methods-use-this
	protectOverlay(popup) {
		if (!popup || !popup.overlay || !popup.overlay.element) return;

		const overlayElement = popup.overlay.element;
		const stopper = event => {
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
		};

		overlayElement.addEventListener('click', stopper, true);
	}
}
